var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31.028 29.528",
    style: {
      fill: "currentColor"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-truck",
    d: "M31,15.7L27.1,8h-5.8V4.1c0-1.1-0.9-1.9-1.9-1.9H1.9C0.9,2.2,0,3,0,4.1v15.5l1.9,1.9h2.5 c-1.1,1.9-0.4,4.2,1.4,5.3s4.2,0.4,5.3-1.4c0.7-1.2,0.7-2.7,0-3.9h10.7c-1.1,1.9-0.4,4.2,1.4,5.3c1.9,1.1,4.2,0.4,5.3-1.4 c0.7-1.2,0.7-2.7,0-3.9H31V15.7L31,15.7z M21.3,15.7V9.9h4l2.9,5.8H21.3L21.3,15.7z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVan);
export default __webpack_public_path__ + "static/media/van.ba192631c52f84e69bc150d30e0461d4.svg";
export { ForwardRef as ReactComponent };